<script setup lang="ts">
import { useOffline } from '../composables/useOffline'

const { isOnline, checkConnectivity } = useOffline()
const retrying = ref(false)
const { t: $t } = useI18n()

const retry = async () => {
	retrying.value = true
	await checkConnectivity()
	retrying.value = false
}
</script>

<template>
	<transition name="fade">
		<div
			v-if="!isOnline"
			class="fixed top-0 inset-x-0 z-50 bg-red-600 text-white text-sm"
			role="status"
			aria-live="assertive"
		>
			<div class="mx-auto max-w-7xl px-4 py-2 flex items-center justify-between gap-3">
				<span class="font-medium">
					{{ $t('No internet connection. Please check your connection and try again') }}.
				</span>
				<button
					class="rounded-md bg-white/10 px-3 py-1.5 hover:bg-white/20 focus:outline-none"
					:disabled="retrying"
					@click="retry"
				>
					{{ retrying ? `${$t('Checking')}…` : $t('Retry') }}
				</button>
			</div>
		</div>
	</transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
